The `PositionOpening` that this profile was created under.
